import { useMemo } from "react";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
var useCalculateZoom = function () {
    var device = DeviceContext();
    var zoom = useMemo(function () {
        var screenWidth = window.screen.width;
        var isMobileorTab = (device === null || device === void 0 ? void 0 : device.isMobile) || (device === null || device === void 0 ? void 0 : device.isTablet);
        if (isMobileorTab) {
            return "100%";
        }
        var zoomRanges = {
            range1: { min: 1023, max: 1299, value: 88 },
            range2: { min: 1300, max: 1499, value: 90 },
            range3: { min: 1500, max: 1699, value: 92 },
        };
        var defaultZoom = 100;
        var matchingRange = Object.values(zoomRanges).find(function (range) { return screenWidth >= range.min && screenWidth <= range.max; });
        var zoomValue = matchingRange ? matchingRange.value : defaultZoom;
        return zoomValue + "%";
    }, [device]);
    return zoom;
};
export default useCalculateZoom;
